"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8177],{

/***/ 71357:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LI": function() { return /* binding */ useIsomorphicLayoutEffect; },
/* harmony export */   "Ui": function() { return /* binding */ mediaQueryHOC; },
/* harmony export */   "ag": function() { return /* binding */ useMatchMedia; },
/* harmony export */   "hZ": function() { return /* binding */ useScrollBlock; },
/* harmony export */   "y3": function() { return /* binding */ updateCurrentProductIndex; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91058);
/* harmony import */ var core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_parse_int_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(85893);














function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_8___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

 // https://github.com/streamich/react-use/blob/master/docs/useIsomorphicLayoutEffect.md


var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_13__.useLayoutEffect : 0;
function useMatchMedia(mediaQueryString) {
  var initialValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)(initialValue),
      match = _useState[0],
      setMatch = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    if (!window.matchMedia) {
      return;
    }

    function handleMatch(event) {
      setMatch(event.matches);
    }

    var matchMedia = window.matchMedia(mediaQueryString);
    setMatch(matchMedia.matches);
    matchMedia.addListener(handleMatch);
    return function () {
      matchMedia.removeListener(handleMatch);
    };
  }, [mediaQueryString]);
  return match;
}
var mediaQueryHOC = function mediaQueryHOC(Component) {
  function MediaQueryHOC(props) {
    var isXSmall = useMatchMedia('(max-width: 375px)');
    var isSmall = useMatchMedia('(max-width: 479px)');
    var isMedium = useMatchMedia('(max-width: 767px)');
    var isLarge = useMatchMedia('(max-width: 991px)');
    var isXLarge = useMatchMedia('(max-width: 1023px)');
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_14__.jsx)(Component, _objectSpread({
      isXSmall: isXSmall,
      isSmall: isSmall,
      isMedium: isMedium,
      isLarge: isLarge,
      isXLarge: isXLarge
    }, props));
  }

  return MediaQueryHOC;
};
var listeners = [];
var state = {
  currentProductIndex: 0
};

var setState = function setState(newState) {
  state = _objectSpread(_objectSpread({}, state), newState);
  listeners.forEach(function (listener) {
    listener(state);
  });
};

var updateCurrentProductIndex = function updateCurrentProductIndex() {
  var newListener = (0,react__WEBPACK_IMPORTED_MODULE_13__.useState)()[1];
  (0,react__WEBPACK_IMPORTED_MODULE_13__.useEffect)(function () {
    listeners.push(newListener);
  }, []);
  return [state, setState];
};
var useScrollBlock = function useScrollBlock() {
  var scroll = (0,react__WEBPACK_IMPORTED_MODULE_13__.useRef)(false);

  var blockScroll = function blockScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document = document,
        body = _document.body;
    if (!(body == null ? void 0 : body.style) || scroll.current) return;
    var scrollBarWidth = window.innerWidth - html.clientWidth;
    var bodyPaddingRight = parseInt(window.getComputedStyle(body).getPropertyValue("padding-right")) || 0;
    Object.assign(html.style, {
      position: "relative",
      overflow: "hidden"
    });
    Object.assign(body.style, {
      position: "relative",
      overflow: "hidden",
      paddingRight: "".concat(bodyPaddingRight + scrollBarWidth, "px")
    });
    scroll.current = true;
  };

  var allowScroll = function allowScroll() {
    if (typeof document === "undefined") return;
    var html = document.documentElement;
    var _document2 = document,
        body = _document2.body;
    if (!(body == null ? void 0 : body.style) || !scroll.current) return;
    Object.assign(html.style, {
      position: "",
      overflow: ""
    });
    Object.assign(body.style, {
      position: "",
      overflow: "",
      paddingRight: ""
    });
    scroll.current = false;
  };

  return [blockScroll, allowScroll];
};

/***/ }),

/***/ 19271:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ optimizeImage; }
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26699);
/* harmony import */ var core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_includes_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32023);
/* harmony import */ var core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_includes_js__WEBPACK_IMPORTED_MODULE_1__);


var optimizeImage = function optimizeImage(imageUrl, imageFormatValue, imageQualityValue) {
  var imageFormat = imageFormatValue ? imageFormatValue : 'webp';
  var imageQuality = imageQualityValue ? imageQualityValue : 85;

  if (imageUrl !== undefined && imageUrl !== null && imageUrl.includes('images.ctfassets.net') && imageUrl.includes('fm=webp') == false && imageUrl.includes('.svg') == false) {
    var _imageUrl;

    if ((_imageUrl = imageUrl) == null ? void 0 : _imageUrl.includes('https')) {
      var _imageUrl2;

      if ((_imageUrl2 = imageUrl) == null ? void 0 : _imageUrl2.includes('?')) {
        imageUrl = imageUrl + "&fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      } else {
        imageUrl = imageUrl + "?fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      }
    } else {
      var _imageUrl3;

      imageUrl = 'https:' + imageUrl;

      if ((_imageUrl3 = imageUrl) == null ? void 0 : _imageUrl3.includes('?')) {
        imageUrl = imageUrl + "&fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      } else {
        imageUrl = imageUrl + "?fm=".concat(imageFormat) + "&q=".concat(imageQuality);
      }
    }
  }

  return imageUrl;
};

/***/ }),

/***/ 88177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(930);
/* harmony import */ var _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(88674);
/* harmony import */ var core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_promise_js__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69826);
/* harmony import */ var core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_find_js__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(21249);
/* harmony import */ var core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_map_js__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67294);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46066);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(71357);
/* harmony import */ var react_lazyload__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(1216);
/* harmony import */ var _adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(19271);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(85893);











function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _home_runner_work_mw_mt_oralb_com_cs_cz_mw_mt_oralb_com_cs_cz_node_modules_next_dist_compiled_babel_runtime_helpers_defineProperty_js__WEBPACK_IMPORTED_MODULE_9___default()(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }








var SeriesComparisonItem = next_dynamic__WEBPACK_IMPORTED_MODULE_16___default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4885), __webpack_require__.e(1036), __webpack_require__.e(8996), __webpack_require__.e(7059)]).then(__webpack_require__.bind(__webpack_require__, 87059));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(87059)];
    }
  }
});


var Image = next_dynamic__WEBPACK_IMPORTED_MODULE_16___default()(function () {
  return __webpack_require__.e(/* import() */ 8084).then(__webpack_require__.bind(__webpack_require__, 48084));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(48084)];
    }
  }
});





function ProductRecommenderABtest(props) {
  var _doc$fields, _doc$fields2, _doc$fields3, _doc$fields10, _doc$fields11, _doc$fields12, _doc$fields13, _doc$fields14, _doc$fields15, _doc$fields16, _doc$fields16$product, _doc$fields18, _doc$fields19;

  var doc = props.document,
      onClickCallback = props.onClickCallback,
      isMedium = props.isMedium,
      isXXLarge = props.isXXLarge,
      isSmall = props.isSmall,
      isXSmall = props.isXSmall,
      isLarge = props.isLarge,
      className = props.className;
  var isDesktopCarousel = doc == null ? void 0 : (_doc$fields = doc.fields) == null ? void 0 : _doc$fields.isCarouselDesktop;
  var leftArrow = doc == null ? void 0 : (_doc$fields2 = doc.fields) == null ? void 0 : _doc$fields2.arrowLeft;
  var rightArrow = doc == null ? void 0 : (_doc$fields3 = doc.fields) == null ? void 0 : _doc$fields3.arrowRight;
  var sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_14__.useRef)(null);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)(0),
      currentIndex = _useState[0],
      setCurrentIndex = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_14__.useState)({
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 1000,
    infinite: true,
    lazyLoad: false,
    autoplay: false,
    prevArrow: false,
    nextArrow: false,
    autoplaySpeed: 6000,
    dots: true,
    centerMode: true,
    centerPadding: '40px'
  }),
      sliderSettings = _useState2[0],
      setSliderSettings = _useState2[1];

  var desktopCarouselSettings = {
    arrows: false,
    slidesToShow: 3,
    slidesToScroll: 3,
    speed: 1000,
    infinite: false,
    lazyLoad: false,
    autoplay: false,
    dots: false,
    beforeChange: function beforeChange(current, next) {
      return setCurrentIndex(next);
    }
  };
  (0,react__WEBPACK_IMPORTED_MODULE_14__.useEffect)(function () {
    var screenWidth = window.innerWidth;
    var breakpoints = [{
      max: 360,
      padding: '28px'
    }, {
      max: 376,
      padding: '35px'
    }, {
      max: 390,
      padding: '40px'
    }, {
      max: 414,
      padding: '53px'
    }, {
      max: 430,
      padding: '60px'
    }];
    var breakpoint = breakpoints.find(function (b) {
      return screenWidth <= b.max;
    }) || {
      padding: '40px'
    };
    setSliderSettings(_objectSpread(_objectSpread({}, sliderSettings), {}, {
      centerPadding: breakpoint.padding
    }));
  }, []);

  var desktopSliderComponent = function desktopSliderComponent() {
    var _leftArrow$fields, _leftArrow$fields$fil, _doc$fields4, _doc$fields4$product, _doc$fields6, _doc$fields7, _rightArrow$fields, _rightArrow$fields$fi;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
      className: "ob-desktop-product-slider",
      children: [currentIndex !== 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("button", {
        className: "ob-carousel-left-arrow",
        tabIndex: 0,
        onClick: function onClick() {
          return sliderRef.current.slickGoTo(currentIndex - 1);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
          src: (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_19__/* .optimizeImage */ .H)(leftArrow == null ? void 0 : (_leftArrow$fields = leftArrow.fields) == null ? void 0 : (_leftArrow$fields$fil = _leftArrow$fields.file) == null ? void 0 : _leftArrow$fields$fil.url),
          alt: "Left Arrow"
        })
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, _objectSpread(_objectSpread({
        "aria-hidden": false,
        ref: sliderRef
      }, desktopCarouselSettings), {}, {
        children: doc == null ? void 0 : (_doc$fields4 = doc.fields) == null ? void 0 : (_doc$fields4$product = _doc$fields4.product) == null ? void 0 : _doc$fields4$product.map(function (productItem, i) {
          var _doc$fields5;

          return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
              className: "ob-series-comparison__item",
              children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(SeriesComparisonItem, {
                document: doc,
                isMedium: isMedium,
                isSmall: isSmall,
                isXSmall: isXSmall,
                product: productItem,
                onClickCallback: onClickCallback ? onClickCallback : doc == null ? void 0 : (_doc$fields5 = doc.fields) == null ? void 0 : _doc$fields5.onClickCallback
              })
            }, i)
          }, i);
        })
      })), (doc == null ? void 0 : (_doc$fields6 = doc.fields) == null ? void 0 : _doc$fields6.product.length) > 3 && currentIndex !== (doc == null ? void 0 : (_doc$fields7 = doc.fields) == null ? void 0 : _doc$fields7.product.length) - 3 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("button", {
        className: "ob-carousel-right-arrow",
        onClick: function onClick() {
          return sliderRef.current.slickGoTo(currentIndex + 1);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("img", {
          src: (0,_adapters_helpers_pagespeedHelper__WEBPACK_IMPORTED_MODULE_19__/* .optimizeImage */ .H)(rightArrow == null ? void 0 : (_rightArrow$fields = rightArrow.fields) == null ? void 0 : (_rightArrow$fields$fi = _rightArrow$fields.file) == null ? void 0 : _rightArrow$fields$fi.url),
          alt: "Left Arrow"
        })
      })]
    });
  };

  var sliderComponent = function sliderComponent() {
    var _doc$fields8, _doc$fields8$product;

    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, _objectSpread(_objectSpread({}, sliderSettings), {}, {
      children: doc == null ? void 0 : (_doc$fields8 = doc.fields) == null ? void 0 : (_doc$fields8$product = _doc$fields8.product) == null ? void 0 : _doc$fields8$product.map(function (productItem, i) {
        var _doc$fields9;

        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("li", {
            className: "ob-series-comparison__item",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(SeriesComparisonItem, {
              document: doc,
              isMedium: isMedium,
              isSmall: isSmall,
              isXSmall: isXSmall,
              product: productItem,
              onClickCallback: onClickCallback ? onClickCallback : doc == null ? void 0 : (_doc$fields9 = doc.fields) == null ? void 0 : _doc$fields9.onClickCallback
            })
          }, i)
        }, i);
      })
    }));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_lazyload__WEBPACK_IMPORTED_MODULE_18__["default"], {
    offset: 100,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
      className: "product-recommender-ab-test ".concat(className ? className : ''),
      id: doc == null ? void 0 : (_doc$fields10 = doc.fields) == null ? void 0 : _doc$fields10.anchorId,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(Image, {
        image: doc == null ? void 0 : (_doc$fields11 = doc.fields) == null ? void 0 : _doc$fields11.backgroundAsset,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
          className: "ob-series-comparison__sizer",
          children: [(doc == null ? void 0 : (_doc$fields12 = doc.fields) == null ? void 0 : _doc$fields12.title) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("h2", {
            className: "ob-series-comparison__title",
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
              children: doc == null ? void 0 : (_doc$fields13 = doc.fields) == null ? void 0 : _doc$fields13.title
            })
          }), (doc == null ? void 0 : (_doc$fields14 = doc.fields) == null ? void 0 : _doc$fields14.subtitle) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            className: "subtitle-text",
            children: doc == null ? void 0 : (_doc$fields15 = doc.fields) == null ? void 0 : _doc$fields15.subtitle
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsxs)("div", {
            children: [(isMedium || isXSmall || isSmall) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
              children: sliderComponent()
            }), !isMedium && !isXSmall && !isSmall && isDesktopCarousel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.Fragment, {
              children: desktopSliderComponent()
            }), !isMedium && !isXSmall && !isSmall && !isDesktopCarousel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("ul", {
              className: "ob-series-comparison__list-product",
              children: doc == null ? void 0 : (_doc$fields16 = doc.fields) == null ? void 0 : (_doc$fields16$product = _doc$fields16.product) == null ? void 0 : _doc$fields16$product.map(function (productItem, i) {
                var _doc$fields17;

                return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("li", {
                  className: "ob-series-comparison__item",
                  children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)(SeriesComparisonItem, {
                    document: doc,
                    product: productItem,
                    onClickCallback: onClickCallback ? onClickCallback : doc == null ? void 0 : (_doc$fields17 = doc.fields) == null ? void 0 : _doc$fields17.onClickCallback
                  })
                }, i);
              })
            })]
          }), (doc == null ? void 0 : (_doc$fields18 = doc.fields) == null ? void 0 : _doc$fields18.seeAllProductsLinks) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_20__.jsx)("div", {
            dangerouslySetInnerHTML: {
              __html: doc == null ? void 0 : (_doc$fields19 = doc.fields) == null ? void 0 : _doc$fields19.seeAllProductsLinks
            },
            className: "see-all-products-conatiner"
          })]
        })
      })
    })
  });
}

/* harmony default export */ __webpack_exports__["default"] = ((0,_adapters_helpers_Hooks__WEBPACK_IMPORTED_MODULE_17__/* .mediaQueryHOC */ .Ui)(ProductRecommenderABtest));

/***/ })

}]);